import Enumerable from "linq";
import {
  ObjectIdValidator,
  ObjectNameValidator,
  ObjectValidator,
  ObjectsValidator,
  FormatPropertyValidator,
  LinkedPageObjectValidator,
} from "./validators";
import { QuestionnaireObjectValidator } from "../questionnaire/validators";
import { IFormatValidatable } from "./IFormatValidatable";
import { FormatStructureEditor } from "./FormatStructureEditor";
import { IFormatAlert } from "./IFormatAlert";

export class FormatValidator implements IFormatValidatable {
  private readonly _validators: IFormatValidatable[] = [
    new ObjectIdValidator(),
    new ObjectNameValidator(),
    new ObjectValidator(),
    new ObjectsValidator(),
    new FormatPropertyValidator(),
    new LinkedPageObjectValidator(),
    new QuestionnaireObjectValidator(),
  ];

  validate(format: FormatStructureEditor): IFormatAlert[] {
    return Enumerable.from(this._validators)
    .where(v => !!v)
    .select(v => v.validate(format))
    .aggregate([] as IFormatAlert[], (s, a) => s.concat(a));
  }
}
